/*
 * @Author: RYL
 * @Description: 报警联系人公共函数（报警通知添加中和报警联系人中需要使用）
 * @Date: 2020-10-28 14:20:53
 * @LastEditTime: 2020-10-28 14:48:25
 */
import { getAlarmContact, deleteAlarmContact } from '@/api/cloudMonitor/alarmList'
export const alarmContact = {
  data() {
    return {
      contactList: [],
      contactSelections: [],
      seek: {
        name: '',
        phone: '',
        email: '',
        wechat: ''
      }
    }
  },
  methods: {
    // 获取联系人列表
    getList() {
      let params = {
        current: this.offset,
        size: this.limit
      }
      getAlarmContact(params).then(res => {
        if(res.data.code === 0) {
          let data = res.data.data
          this.contactList = data.records
          this.contactList.unshift({})
          this.total = data.total
        }
      })
    },
    addContact() {
      this.$refs.contDialog.show()
    },
    // 编辑
    editcontactList(row) {
      this.$refs.contDialog.show(row)
    },
    // 刪除
    deleteContact(row) {
      deleteAlarmContact(row.id).then(res => {
        if(res.data.code === 0) {
          this.$message.success(this.$t('lang.Button.successDelete'))
          this.offset = 1
          this.getList()
        }else{
          this.$message.error('删除失败，请重试！')
        }
      }).catch(() => {})
    },
    // 获取选中项
    handleSelectionChange(val) {
      this.contactSelections = val
    }
  }
}
